const weeksOfMonth = Object.freeze({
    first: 1,
    second: 2,
    third: 3,
    fourth: 4,
    fifth: 5
});

export default weeksOfMonth;
